/**
 * 🎆 PyrotechnicSetBadge — inline mini badge shown next to the user's handle
 * on their Profile once they own all 5 pieces of the Pyrotechnic Phoenix set.
 *
 * Silent (renders nothing) when the user has fewer than 5 pieces.
 * Owner may show partial progress via `mode="always"` if desired.
 */
import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PyrotechnicSetBadge({ mode = "complete_only" }) {
  const [data, setData] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const r = await axios.get(`${API}/pyrotechnic-phoenix/mine`);
        if (!cancelled) setData(r.data);
      } catch (_e) { /* silent */ }
    })();
    return () => { cancelled = true; };
  }, []);

  if (!data) return null;
  const owned = data.owned_count || 0;
  const total = data.total_pieces || 5;
  const complete = owned >= total;

  if (mode === "complete_only" && !complete) return null;
  if (!complete && mode === "always" && owned === 0) return null;

  return (
    <span
      className={
        "inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-bold border align-middle " +
        (complete
          ? "bg-gradient-to-r from-red-500 via-yellow-400 to-blue-500 text-black border-yellow-200/60 shadow-[0_0_18px_rgba(245,158,11,0.55)] animate-pulse"
          : "bg-neutral-800/60 border-neutral-600 text-amber-200")
      }
      title={complete
        ? "Pyrotechnic Phoenix — full 5-piece set"
        : `Pyrotechnic Phoenix — ${owned}/${total} pieces`}
      data-testid="pyrotechnic-set-badge"
      data-complete={complete ? "1" : "0"}
    >
      <span className="text-xs">🎆</span>
      <span>{owned}/{total}</span>
    </span>
  );
}
